(function () {
  const BRINDES = [{ sku: 'brinde1', variantId: 46650884522156, minimo: 160000 }];
  const SOURCE = 'gerenciar-brindes';
  const root = window.Shopify?.routes?.root || '/';
  const cartAddUrl = window.routes?.cart_add_url || `${root}cart/add.js`;
  const cartUpdateUrl = window.routes?.cart_update_url || `${root}cart/update.js`;
  const cartUrl = `${root}cart.js`;

  function getSectionsToRender() {
    const sections = [];
    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartFooter = document.getElementById('main-cart-footer');

    if (mainCartItems) {
      sections.push({ id: 'main-cart-items', section: mainCartItems.dataset.id, selector: '.js-contents' });
      sections.push({ id: 'cart-live-region-text', section: 'cart-live-region-text', selector: '.shopify-section' });
    }

    if (mainCartFooter) {
      sections.push({ id: 'main-cart-footer', section: mainCartFooter.dataset.id, selector: '.js-contents' });
    }

    if (document.querySelector('cart-drawer')) {
      sections.push({ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' });
    }

    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    if (!html) return null;
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return element ? element.innerHTML : null;
  }

  function renderSections(sections, sectionsPayload, cart) {
    sections.forEach((section) => {
      const container = document.getElementById(section.id);
      const target = container?.querySelector(section.selector) || container;
      const html = getSectionInnerHTML(sectionsPayload?.[section.section], section.selector);

      if (target && html !== null) target.innerHTML = html;
    });

    document.querySelector('cart-items')?.classList.toggle('is-empty', cart.item_count === 0);
    document.querySelector('cart-drawer')?.classList.toggle('is-empty', cart.item_count === 0);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cart.item_count === 0);

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: cart });
    }
  }

  function withSource(url) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}source=${SOURCE}`;
  }

  async function fetchCart() {
    const response = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Falha ao consultar o carrinho: ${response.status}`);
    return response.json();
  }

  async function postCart(url, body) {
    const response = await fetch(withSource(url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

    if (!response.ok) throw new Error(`Falha ao atualizar o carrinho: ${response.status}`);
    return response.json();
  }

  function isGift(item) {
    return BRINDES.some((gift) => gift.sku === item.sku);
  }

  function getDesiredGift(cart) {
    const subtotal = cart.items
      .filter((item) => !isGift(item))
      .reduce((sum, item) => sum + (item.original_line_price ?? item.final_line_price), 0);

    return BRINDES.filter((gift) => subtotal >= gift.minimo).sort((a, b) => b.minimo - a.minimo)[0] || null;
  }

  function isNormalized(giftLines, desiredGift) {
    if (!desiredGift) return giftLines.length === 0;

    const desiredQuantity = giftLines
      .filter((item) => item.sku === desiredGift.sku)
      .reduce((sum, item) => sum + item.quantity, 0);
    const hasAnotherGift = giftLines.some((item) => item.sku !== desiredGift.sku);

    return desiredQuantity === 1 && !hasAnotherGift;
  }

  async function applyGiftNormalization(cart, desiredGift, sectionIds, sectionsUrl) {
    const giftLines = cart.items.filter(isGift);
    if (isNormalized(giftLines, desiredGift)) return null;

    let response = null;

    if (giftLines.length > 0) {
      const updates = Object.fromEntries(giftLines.map((item) => [item.key, 0]));
      response = await postCart(cartUpdateUrl, { updates, sections: sectionIds, sections_url: sectionsUrl });
    }

    if (desiredGift) {
      response = await postCart(cartAddUrl, {
        items: [{ id: desiredGift.variantId, quantity: 1 }],
        sections: sectionIds,
        sections_url: sectionsUrl,
      });
    }

    return response;
  }

  // Serializes every gift add/remove so two near-simultaneous cart mutations (e.g. a
  // double click) can't both decide "gift missing" and both add it before either sees
  // the other's write — each queued turn re-reads the cart fresh before acting.
  let giftLock = Promise.resolve();
  function withGiftLock(task) {
    const run = giftLock.then(task, task);
    giftLock = run.then(
      () => {},
      () => {}
    );
    return run;
  }

  let checking = false;
  let pending = false;
  let timer;

  function scheduleCheck(delay = 250) {
    clearTimeout(timer);
    timer = setTimeout(checkCart, delay);
  }

  // Full sync used on page load and as a fallback path: fetches the cart, normalizes
  // the gift and re-renders every known cart container (drawer, footer, icon, etc).
  async function checkCart() {
    if (checking) {
      pending = true;
      return;
    }

    checking = true;

    try {
      await withGiftLock(async () => {
        const cart = await fetchCart();
        if (!Array.isArray(cart.items)) return;

        const desiredGift = getDesiredGift(cart);
        const sections = getSectionsToRender();
        const sectionIds = sections.map((section) => section.section);
        const response = await applyGiftNormalization(cart, desiredGift, sectionIds, window.location.pathname);

        if (!response) return;

        const updatedCart = await fetchCart();
        renderSections(sections, response.sections, updatedCart);
      });
    } catch (error) {
      console.error('Erro ao gerenciar brindes:', error);
    } finally {
      checking = false;

      if (pending) {
        pending = false;
        scheduleCheck(0);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scheduleCheck(0), { once: true });
  } else {
    scheduleCheck(0);
  }

  // Reads the `sections`/`sections_url` the theme itself requested in a cart mutation,
  // so we can ask the cart API for the same keys when adjusting the gift and hand the
  // theme back one merged response — instead of letting it render once without the
  // gift and then rendering our own update ~250ms later, which looked like a page
  // refresh (double innerHTML swap of the cart drawer/icon/footer).
  function parseRequestedSections(init) {
    const body = init?.body;

    if (body instanceof FormData) {
      const raw = body.get('sections');
      try {
        return {
          sectionIds: raw ? JSON.parse(raw) : [],
          sectionsUrl: body.get('sections_url') || window.location.pathname,
        };
      } catch {
        return { sectionIds: [], sectionsUrl: window.location.pathname };
      }
    }

    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);
        return {
          sectionIds: Array.isArray(parsed.sections) ? parsed.sections : [],
          sectionsUrl: parsed.sections_url || window.location.pathname,
        };
      } catch {
        return { sectionIds: [], sectionsUrl: window.location.pathname };
      }
    }

    return { sectionIds: [], sectionsUrl: window.location.pathname };
  }

  async function mergeGiftIntoResponse(response, requestInit) {
    const { sectionIds: requestedSectionIds, sectionsUrl } = parseRequestedSections(requestInit);

    // Caller didn't ask for sections at all (so the theme won't render off this
    // response anyway) — nothing to merge into; fall back to the full async sync.
    if (requestedSectionIds.length === 0) {
      scheduleCheck();
      return response;
    }

    const originalPayload = await response.clone().json();

    const merged = await withGiftLock(async () => {
      const cart = await fetchCart();
      if (!Array.isArray(cart.items)) return null;

      const desiredGift = getDesiredGift(cart);
      const giftLines = cart.items.filter(isGift);
      if (isNormalized(giftLines, desiredGift)) return { sections: null };

      const knownSections = getSectionsToRender();
      const extraSections = knownSections.filter((section) => !requestedSectionIds.includes(section.section));
      const allSectionIds = [...requestedSectionIds, ...extraSections.map((section) => section.section)];

      const latest = await applyGiftNormalization(cart, desiredGift, allSectionIds, sectionsUrl);
      if (!latest?.sections) return null;

      if (extraSections.length > 0) {
        const updatedCart = await fetchCart();
        renderSections(extraSections, latest.sections, updatedCart);
      }

      return { sections: latest.sections };
    });

    if (!merged) {
      // Something failed mid-normalization (e.g. a cart API call errored) — retry via
      // the debounced full sync instead of silently leaving the gift out of sync.
      scheduleCheck();
      return response;
    }

    if (!merged.sections) return response; // already normalized, nothing to merge

    const mergedSections = Object.fromEntries(
      requestedSectionIds
        .map((id) => [id, merged.sections[id]])
        .filter(([, html]) => html !== undefined)
    );

    return new Response(JSON.stringify({ ...originalPayload, sections: mergedSections }), {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    });
  }

  const originalFetch = window.fetch;
  window.fetch = function (...args) {
    const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    const isCartMutation = /\/cart\/(add|change|update)(\.js)?([?#]|$)/.test(requestUrl);

    return originalFetch.apply(this, args).then(async (response) => {
      if (!response.ok || !isCartMutation || requestUrl.includes(`source=${SOURCE}`)) {
        return response;
      }

      try {
        return await mergeGiftIntoResponse(response, args[1]);
      } catch (error) {
        console.error('Erro ao gerenciar brindes:', error);
        scheduleCheck();
        return response;
      }
    });
  };
})();
